import SidebarBottomContent from './SidebarBottomContent';

export default SidebarBottomContent;
